import React, { useState } from 'react'
import styled from 'styled-components'
import Modal from '../modal'
import Button from '../button'
import LoadingButton from '../loading-button'
import UpdateDocumentComment from '../../queries/UpdateDocumentComment'
import { useMutation } from '@apollo/react-hooks'
import { useSnackbar } from '../../contexts/SnackbarContext'
import { SendNoteModalVariant } from './constants'
import TextArea from '../text-area'

const ButtonsContainerElement = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 10px;
`

const SubtitleElement = styled.h4`
  font-size: 0.9rem !important;
  font-weight: 200 !important;
  margin: 0 0 1rem 0 !important;
`

function SendNoteModal({
  note,
  documentId,
  onClose,
  variant = SendNoteModalVariant.DEFAULT,
  onSuccess = () => {},
}) {
  const { setSuccessMessage, setErrorMessage } = useSnackbar()
  const [noteValue, setNoteValue] = useState(note || '')

  const [updateCommentMutation, { loading }] = useMutation(
    UpdateDocumentComment,
    {
      onCompleted: () => {
        onSuccess()
        onClose()

        if (variant === SendNoteModalVariant.DEFAULT)
          setSuccessMessage('Document note successfully sent')
      },
      onError: () =>
        setErrorMessage('There was an error saving the document note'),
    }
  )

  const handleClose = () => !loading && onClose()
  const enableSubmit = noteValue.length > 0 && !loading && noteValue !== note

  const handleSubmit = () =>
    updateCommentMutation({
      variables: {
        input: {
          documentId,
          comment: noteValue,
        },
      },
    })

  return (
    <Modal title="Send a note to the applicant" onClose={handleClose}>
      {variant === SendNoteModalVariant.REJECTION_REASON && (
        <SubtitleElement>Provide reason for the rejection</SubtitleElement>
      )}
      <TextArea
        placeholder="Please add any additional comments to the applicant. This will appear on the applicant’s document uploads page and the document status update."
        value={noteValue}
        onChange={(e) => setNoteValue(e.target.value)}
        minHeight="6.5rem"
        minWidth="30rem"
      />
      <ButtonsContainerElement>
        <Button color="gray" variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <LoadingButton
          disabled={!enableSubmit}
          isLoading={loading}
          onClick={handleSubmit}
          width="5rem"
        >
          Send
        </LoadingButton>
      </ButtonsContainerElement>
    </Modal>
  )
}

export default SendNoteModal
